<!-- Component that implements a list of documents -->
<template lang="html">
  <div>
    <v-data-table
    :headers="headers"
    :items="listaClassificacoes"
    :search="search"
    :no-data-text="'Este projeto não possui classificações.'"
    must-sort
    :sort-by.sync="sortBy"
    :sort-desc.sync="sortDesc"
    :items-per-page="itemsPerPage"
    :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
    >
      <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
        Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaClassificacoes.length }} classificações
      </template>
    </v-data-table>
    <br><br>

    <c-card-footer
      :projeto="this.projeto"
      :extensao="this.extensao"
      proxima="ExtensaoProjeto"
      editar="EditarClassificacao"
      nome_editar="Editar"
      :habilitaBotaoGerarPDFAcao=true
      :habilitaBotaoFinalizarAcao=true
    >
    </c-card-footer>

  </div>
</template>

<script>
import CardFooter from '@/components/c-card-footer'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapGetters, mapActions } from 'vuex'

export default {
  props: ['idProjeto', 'projeto', 'extensao'],
  data: () => ({
    listaClassificacoes: [],
    dates: dates,
    search: null,
    sortBy: 'funcao.descricao',
    sortDesc: false,
    itemsPerPage: 25,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Tipo', align: 'left', width: '50%', value: 'tipoClassificacao' },
      { text: 'Classificação', align: 'left', width: '50%', value: 'descricao' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' })
    projetos.getClassificacoesDoProjeto(this.idProjeto)
    .then(response => {
      /* Ticket #315808 - Resolução CEPE/UFES nº 127/2025  */
      this.listaClassificacoes = response.data.filter(c => c.classificacaoItem !== 125)
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'c-card-footer': CardFooter
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// projeto-classificacoes-tabela.vue?02c446da